import { render, staticRenderFns } from "./EmailModal.vue?vue&type=template&id=47816ac4&scoped=true&"
import script from "./EmailModal.vue?vue&type=script&lang=js&"
export * from "./EmailModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailModal.vue?vue&type=style&index=0&id=47816ac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47816ac4",
  null
  
)

export default component.exports